//
import Model from '@/models/Model'

/**
 * This class describes a sl sale debit note.
 * @class      SlSaleDebitNote (name)
 */
export default class SlSaleDebitNote extends Model {
    //
    static includes = ['sl_customer', 'sl_customer_branch_offices']

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_branch_offices_address() {
        return this.getProperty('sl_customer_branch_offices.address', '-')
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_business_name() {
        return this.getProperty('sl_customer.business_name', '-')
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_sale_invoice_customer_business_name() {
        return this.getProperty('sl_sale_invoice.sl_customer.business_name', '')
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_sale_invoice_total() {
        return this.getProperty('sl_sale_invoice.total', '')
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get was_replaced_str() {
        return this.getProperty('was_replaced', false) ? 'Si' : 'No'
    }

    /**
     * { function_description }
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'sl_sale_debit_note'
    }

    /**
     * Returns a create representation of the object.
     * @return     {<type>}  Create representation of the object.
     */
    toCreate() {
        return this.clean([
            'type_reference_document',
            'dte_number',
            'reason',
            'total_amount',
        ])
    }

    downloadPdf() {
        return new Promise((resolve, reject) =>
            this.$http
                .get(
                    process.env.VUE_APP_API_ROUTE +
                        '/sl_sale_debit_note/' +
                        this.id +
                        '/pdf',
                    { responseType: 'blob' }
                )
                .then(response => {
                    const linkSource = URL.createObjectURL(response.data)
                    const downloadLink = document.createElement('a')
                    const fileName = `${this.number}-NOTA_DE_DEBITO_ELECTRONICA.pdf`
                    downloadLink.href = linkSource
                    downloadLink.download = fileName
                    downloadLink.click()
                    resolve()
                })
                .catch(reject)
        )
    }
}
